<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Raw Material Purchase
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="Raw Material Purchase"
                outlined
                v-model="form.raw_material_id"
                :items="rawmaterialItems"
                label="Raw Material"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.raw_material_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.date"
                    label="Date"
                    prepend-inner-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  @input="menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.quantity"
                outlined
                label="Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Raw Material Purchase
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "RawMaterialPurchaseCreatePage",
  data() {
    return {
      form: {
        raw_material_id: "",
        quantity: 0,
        name: "",
      },
      isLoading: false,
      rawmaterialItems: [],
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`raw_material_purchases/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.rawmaterials.forEach((rawmaterial) => {
            this.rawmaterialItems.push({
              id: rawmaterial.id,
              text: rawmaterial.name,
              value: rawmaterial.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          window.location.href = "/auth/login";
        });
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/raw_material_purchases", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push("/raw-material-purchases");
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
